<script>
export default { name: 'CatalogProductsModal' };
</script>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ProductsPicker from './ProductsPicker.vue';
import ProductSendConfirm from './ProductSendConfirm.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  inboxId: {
    type: Number,
    default: undefined,
  },
});

const emit = defineEmits(['onSend', 'close', 'update:show']);
const { t } = useI18n();

const selectedProducts = ref([]);
const catalogId = ref(null);
const messageType = ref('product');
const step = ref('pick'); // 'pick' or 'confirm'

const onClose = () => {
  selectedProducts.value = [];
  catalogId.value = null;
  messageType.value = 'product';
  step.value = 'pick';
  emit('close');
};

const localShow = computed({
  get: () => props.show,
  set: value => emit('update:show', value),
});

const headerContent = computed(() => {
  if (step.value === 'confirm' && selectedProducts.value.length > 0) {
    return t('CATALOG_PRODUCTS.SELECTED', {
      count: selectedProducts.value.length,
    });
  }
  return '';
});

const onSelectProducts = (products, catId, type = 'product') => {
  selectedProducts.value = products;
  catalogId.value = catId;
  messageType.value = type;
  step.value = 'confirm';
};

const onBack = () => {
  step.value = 'pick';
};

const onSend = payload => {
  emit('onSend', payload);
  onClose();
};
</script>

<template>
  <woot-modal v-model:show="localShow" :on-close="onClose" size="modal-big">
    <woot-modal-header
      :header-title="t('CATALOG_PRODUCTS.TITLE')"
      :header-content="headerContent"
    />
    <div class="p-6">
      <ProductsPicker
        v-if="step === 'pick'"
        :inbox-id="inboxId"
        @on-select="onSelectProducts"
      />
      <ProductSendConfirm
        v-else
        :products="selectedProducts"
        :catalog-id="catalogId"
        :message-type="messageType"
        @back="onBack"
        @send="onSend"
      />
    </div>
  </woot-modal>
</template>
